import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/autocomplete';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, TitleStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GOOGLE_MAPS } from '@vmspdb/contracts';
import {
  AUTH_DISPATCHER_SETTINGS,
  AuthGuard,
  formlyModules,
  GoogleMapsService,
  LOGIN_SITE,
  opentelemetryModules,
  opentelemetryProviders,
} from '@vmspdb/ui/common';
import {
  CHANGELOG,
  CustomTitleStrategyService,
  DefaultChangelogService,
  DefaultSidebarNavigatorService,
  PAGE_TITLE_PREFIX,
  SIDEBAR_NAVIGATION,
} from '@vmspdb/ui/layouts';
import { enUS } from 'date-fns/locale';
import { NgProgressbar } from 'ngx-progressbar';
import { NgProgressHttp, provideNgProgressHttp } from 'ngx-progressbar/http';
import {
  NgProgressRouter,
  provideNgProgressRouter,
} from 'ngx-progressbar/router';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import {
  connectProviders,
  firebaseProviders,
  firebaseServices,
  nebularModules,
  nebularServices,
  otherModules,
  storeModules,
} from './bootstrap';
import { loadSettings } from './store/settings/settings.actions';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, {
      initialNavigation: 'enabledBlocking',
      bindToComponentInputs: true,
      // enableTracing: isDevMode(),
      paramsInheritanceStrategy: 'always',
    }),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    ...nebularModules,
    ...storeModules,
    ...formlyModules,
    ...otherModules,
    ...opentelemetryModules(environment.opentelemetry),
    ReactiveFormsModule,
    NgProgressbar,
    NgProgressHttp,
    NgProgressRouter,
  ],
  providers: [
    Title,
    provideNgProgressHttp({}),
    provideNgProgressRouter({}),
    {
      provide: SIDEBAR_NAVIGATION,
      useClass: DefaultSidebarNavigatorService,
    },
    {
      provide: CHANGELOG,
      useClass: DefaultChangelogService,
    },
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategyService,
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandlerService,
    // },
    {
      provide: PAGE_TITLE_PREFIX,
      useValue: 'VMS Admin',
    },
    {
      provide: LOGIN_SITE,
      useValue: 'Admin',
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: enUS,
    },
    {
      provide: GOOGLE_MAPS,
      useClass: GoogleMapsService,
    },
    {
      provide: AUTH_DISPATCHER_SETTINGS,
      useValue: loadSettings,
    },
    AuthGuard,
    ...nebularServices,
    ...firebaseProviders,
    ...firebaseServices,
    ...connectProviders,
    ...opentelemetryProviders(environment.opentelemetry),
    MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
    MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
  ],
})
export class AppModule {}
